var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Messages } from '@openreplay/tracker';
export default function (opts = {}) {
    const options = Object.assign({
        overrideGlobal: false,
        failuresOnly: false,
        ignoreHeaders: ['Cookie', 'Set-Cookie', 'Authorization'],
    }, opts);
    if (options.requestSanitizer && options.responseSanitizer) {
        console.warn("OpenReplay fetch plugin: `requestSanitizer` and `responseSanitizer` options are depricated. Please, use `sanitiser` instead (check out documentation at https://docs.openreplay.com/plugins/fetch).");
    }
    const origFetch = window.fetch;
    return (app) => {
        if (app === null) {
            return origFetch;
        }
        const ihOpt = options.ignoreHeaders;
        const isHIgnoring = Array.isArray(ihOpt)
            ? name => ihOpt.includes(name)
            : () => ihOpt;
        const fetch = (input, init = {}) => __awaiter(this, void 0, void 0, function* () {
            if (typeof input !== 'string') {
                return origFetch(input, init);
            }
            if (options.sessionTokenHeader) {
                const sessionToken = app.getSessionToken();
                if (sessionToken) {
                    if (init.headers === undefined) {
                        init.headers = {};
                    }
                    if (init.headers instanceof Headers) {
                        init.headers.append(options.sessionTokenHeader, sessionToken);
                    }
                    else if (Array.isArray(init.headers)) {
                        init.headers.push([options.sessionTokenHeader, sessionToken]);
                    }
                    else {
                        init.headers[options.sessionTokenHeader] = sessionToken;
                    }
                }
            }
            const startTime = performance.now();
            const response = yield origFetch(input, init);
            const duration = performance.now() - startTime;
            if (options.failuresOnly && response.status < 400) {
                return response;
            }
            const r = response.clone();
            r.text().then(text => {
                // Headers prepearing
                const reqHs = {};
                const resHs = {};
                if (ihOpt !== true) {
                    function writeReqHeader([n, v]) {
                        if (!isHIgnoring(n)) {
                            reqHs[n] = v;
                        }
                    }
                    if (init.headers instanceof Headers) {
                        init.headers.forEach((v, n) => writeReqHeader([n, v]));
                    }
                    else if (Array.isArray(init.headers)) {
                        init.headers.forEach(writeReqHeader);
                    }
                    else if (typeof init.headers === 'object') {
                        Object.entries(init.headers).forEach(writeReqHeader);
                    }
                    r.headers.forEach((v, n) => { if (!isHIgnoring(n))
                        resHs[n] = v; });
                }
                const req = {
                    headers: reqHs,
                    body: init.body,
                };
                // Response forming
                const res = {
                    headers: resHs,
                    body: text,
                };
                const method = typeof init.method === 'string'
                    ? init.method.toUpperCase()
                    : 'GET';
                let reqResInfo = {
                    url: input,
                    method,
                    status: r.status,
                    request: req,
                    response: res,
                };
                if (options.sanitiser) {
                    try {
                        reqResInfo.response.body = JSON.parse(text); // Why the returning type is "any"?
                    }
                    catch (_a) { }
                    reqResInfo = options.sanitiser(reqResInfo);
                    if (!reqResInfo) {
                        return;
                    }
                }
                const getStj = (r) => {
                    if (r && typeof r.body !== 'string') {
                        try {
                            r.body = JSON.stringify(r.body);
                        }
                        catch (_a) {
                            r.body = "<unable to stringify>";
                            //app.log.warn("Openreplay fetch") // TODO: version check
                        }
                    }
                    return JSON.stringify(r);
                };
                app.send(Messages.Fetch(method, String(reqResInfo.url), getStj(reqResInfo.request), getStj(reqResInfo.response), r.status, startTime + performance.timing.navigationStart, duration));
            });
            return response;
        });
        if (options.overrideGlobal) {
            window.fetch = fetch;
        }
        return fetch;
    };
}
